/**
 * Locale slice — tracks the active UI language code (e.g. "en", "de").
 * Seeded from appConfig.locale so the default matches the build-time config.
 * Components should read currentLang via the useTranslation hook rather than
 * this slice directly; update it via setLang when the user changes language.
 */
import { createSlice } from '@reduxjs/toolkit'
import appConfig from '@/configs/app.config'

export type LocaleState = {
    currentLang: string
}

const initialState: LocaleState = {
    currentLang: appConfig.locale,
}

export const localeSlice = createSlice({
    name: 'locale',
    initialState,
    reducers: {
        setLang: (state, action) => {
            state.currentLang = action.payload
        },
    },
})

export const { setLang } = localeSlice.actions

export default localeSlice.reducer
